import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoBar } from '@/components/feedback/InfoBar';
import { useRadar360UnavailableMetricKeys } from '@/hooks/useRadar360UnavailableMetricKeys';
import { snakeToCamel } from '@/utils/queries';

const RadarThreeSixtyUnavailableInfoBarWithData = () => {
  const { t } = useTranslation(['dataVis', 'metrics']);
  const unavailable360MetricKeys = useRadar360UnavailableMetricKeys();

  if (unavailable360MetricKeys.length === 0) return null;

  const metricNames = `${unavailable360MetricKeys
    .map(key => t(`${snakeToCamel(key)}.name`, { ns: 'metrics' }))
    .join(', ')}.`;

  return (
    <InfoBar mainText={`${t('threeSixtyUnavailableInfoBar')} ${t('affectedMetrics')}`} additionalText={metricNames} />
  );
};

export const RadarThreeSixtyUnavailableInfoBar = () => (
  <Suspense>
    <RadarThreeSixtyUnavailableInfoBarWithData />
  </Suspense>
);
